"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfferPromotionContextValue = exports.useOfferPromotionContext = void 0;
const react_1 = __importDefault(require("react"));
const OfferPromotionContext = react_1.default.createContext({
    showPromotionModal: false,
    setShowPromotionModal: () => false,
    promotingOffer: {},
    setPromotingOffer: () => null,
    isPromotedAutomatically: false,
    setIsPromotedAutomatically: () => null,
});
const useOfferPromotionContext = () => {
    const [showPromotionModal, setShowPromotionModal] = react_1.default.useState(false);
    const [promotingOffer, setPromotingOffer] = react_1.default.useState(null);
    const [isPromotedAutomatically, setIsPromotedAutomatically] = react_1.default.useState(false);
    return {
        OfferPromotionContextProvider: OfferPromotionContext.Provider,
        value: {
            showPromotionModal,
            setShowPromotionModal: (b) => {
                setShowPromotionModal(b);
            },
            promotingOffer,
            setPromotingOffer: (o) => {
                setPromotingOffer(o);
            },
            isPromotedAutomatically,
            setIsPromotedAutomatically: (v) => {
                setIsPromotedAutomatically(v);
            },
        },
    };
};
exports.useOfferPromotionContext = useOfferPromotionContext;
const useOfferPromotionContextValue = () => {
    const context = react_1.default.useContext(OfferPromotionContext);
    return context;
};
exports.useOfferPromotionContextValue = useOfferPromotionContextValue;
